import { createContext } from "react";
import { FEATURE_CONFIG } from "@services/featureConfig/constants";

export type TFeatureConfigContextState = typeof FEATURE_CONFIG;

export const FeatureConfigContext =
  createContext<TFeatureConfigContextState>(FEATURE_CONFIG);
